import React from "react";
import LegalPage from "./LegalPage";
import data from "@content/legal/about.json";

const AboutUs = () => (
    <LegalPage slug="about-us" data={data} crumbLabel="About Us" />
);

export default AboutUs;
